export var ReminderType;
(function (ReminderType) {
    ReminderType["NONE"] = "";
    ReminderType["DAILY_CHECK"] = "DailyCheck";
})(ReminderType || (ReminderType = {}));
export const reminderConfigurations = {
    [ReminderType.DAILY_CHECK]: {
        type: ReminderType.DAILY_CHECK,
        title: 'Daily Check',
        description: 'Get a reminder if Daily Checks are not complete',
    },
};
export const reminderTypesList = Object.values(reminderConfigurations);
export var ReminderRecipientsChannel;
(function (ReminderRecipientsChannel) {
    ReminderRecipientsChannel["USER_EMAIL"] = "USER_EMAIL";
    ReminderRecipientsChannel["USER_GROUP_EMAIL"] = "USER_GROUP_EMAIL";
})(ReminderRecipientsChannel || (ReminderRecipientsChannel = {}));
export var ReminderScheduleWeekDay;
(function (ReminderScheduleWeekDay) {
    ReminderScheduleWeekDay["MONDAY"] = "MONDAY";
    ReminderScheduleWeekDay["TUESDAY"] = "TUESDAY";
    ReminderScheduleWeekDay["WEDNESDAY"] = "WEDNESDAY";
    ReminderScheduleWeekDay["THURSDAY"] = "THURSDAY";
    ReminderScheduleWeekDay["FRIDAY"] = "FRIDAY";
    ReminderScheduleWeekDay["SATURDAY"] = "SATURDAY";
    ReminderScheduleWeekDay["SUNDAY"] = "SUNDAY";
})(ReminderScheduleWeekDay || (ReminderScheduleWeekDay = {}));
